import React, {PureComponent, ReactNode} from 'react';
import {openRegistration} from 'app/components/auth/auth';

interface SignInButtonProps {
    title?: string
    usingOnTab: string
    className?: string
    children?: ReactNode | ReactNode[]
}
export class SignInButton extends PureComponent<SignInButtonProps> {
    handleRedirectClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        const {usingOnTab} = this.props;
        openRegistration(usingOnTab, null, 'login');
    };

    render(): React.ReactNode {
        const {title, className, children} = this.props;
        return <button
            className={`${className ? className : 'button-adaptive'}`}
            onClick={this.handleRedirectClick}>
            {title}{children}
        </button>;
    }
}
